const AUTH_BASE_URL = 'https://tophamtechbe.com/api/treas/auth';

const postAuth = (path, payload) => fetch(`${AUTH_BASE_URL}/${path}`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(payload)
});

export const signIn = (credentials) => postAuth('signin', credentials);
export const signUp = (registration) => postAuth('signup', registration);
export const requestPasswordReset = (request) => postAuth('password-reset', request);
